module.exports = __webpack_public_path__ + "static/media/1.2be0f730.jpg";